function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import classNames from "classnames";
import moment from "moment-timezone";
import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import Tab from "react-bootstrap/Tab";
import Table from "react-bootstrap/Table";
import Tabs from "react-bootstrap/Tabs";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Chart } from "react-google-charts";
import { FilterContext } from "../index";
import { APPS_WEBSITE_USAGE_QUERY, APPS_WEBSITE_USAGE_TEAM_QUERY, APPS_WEBSITE_USAGE_USER_QUERY, APPS_WEBSITE_USAGE_TEAM_USER_QUERY } from "./query";
import "./AppsSummary.css";
import Loader from "../Loader/Loader";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import { convertSecToHoursAndMinutesWithTextShortForm, colors } from "../utils";
import Form from "react-bootstrap/Form";
var LIMIT = 10;
var AppsSummary = function AppsSummary(props) {
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationUserCount = _React$useContext.organisationUserCount,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    organisationSettings = _React$useContext.organisationSettings,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var loadPage = role === "Admin" || role === null;
  var Redirect = props.redirect,
    location = props.location,
    Link = props.linkComponent,
    linkProps = props.linkProps;
  return /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root"
  }, /*#__PURE__*/React.createElement(AllAppAndWebsiteList, {
    teamId: teamId,
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    location: location,
    loadPage: loadPage,
    organisationSettings: organisationSettings,
    Link: Link,
    linkProps: linkProps
  }));
};
var AllAppAndWebsiteList = function AllAppAndWebsiteList(props) {
  var _appsWebsiteUsageList5, _appsWebsiteUsageList6, _appsWebsiteUsageList7, _appsWebsiteUsageList8, _appsWebsiteUsageList9;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeApps = _React$useState2[0],
    setActiveApps = _React$useState2[1];
  var teamId = props.teamId,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    location = props.location,
    loadPage = props.loadPage,
    organisationSettings = props.organisationSettings,
    Link = props.Link,
    linkProps = props.linkProps;
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    unselectAll = _React$useState4[0],
    setUnselectAll = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isUserLoadingMore = _React$useState6[0],
    setUserIsLoadingMore = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isUserAllLoaded = _React$useState8[0],
    setUserIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    tabData = _React$useState10[0],
    setTabData = _React$useState10[1];
  var _useQuery = useQuery(APPS_WEBSITE_USAGE_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      skip: !loadPage
    }),
    appsWebsiteUsageListingData = _useQuery.data,
    appsWebsiteUsageListingError = _useQuery.error,
    appsWebsiteUsageListingLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  var _useLazyQuery = useLazyQuery(APPS_WEBSITE_USAGE_TEAM_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getTeam = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    appsWebsiteUsageListingLoadingTeam = _useLazyQuery2$.loading,
    appsWebsiteUsageListingDataTeam = _useLazyQuery2$.data,
    teamFetchMore = _useLazyQuery2$.fetchMore;
  var _useLazyQuery3 = useLazyQuery(APPS_WEBSITE_USAGE_TEAM_USER_QUERY),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getUser = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    appsWebsiteUsageListingLoadingUser = _useLazyQuery4$.loading,
    appsWebsiteUsageListingDataUser = _useLazyQuery4$.data,
    fetchMore = _useLazyQuery4$.fetchMore;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [location.key]);
  React.useEffect(function () {
    setUserIsAllLoaded(false);
  }, [activeApps]);
  React.useEffect(function () {
    setActiveApps(null);
  }, [startDate, endDate, teamId]);
  function handleScroll(e) {
    var _appsWebsiteUsageList, _appsWebsiteUsageList2;
    if (appsWebsiteUsageListingLoadingUser) return;
    setUserIsLoadingMore(true);
    fetchMore({
      variables: {
        offset: appsWebsiteUsageListingDataUser === null || appsWebsiteUsageListingDataUser === void 0 ? void 0 : (_appsWebsiteUsageList = appsWebsiteUsageListingDataUser.appsWebsiteUsageListingUser) === null || _appsWebsiteUsageList === void 0 ? void 0 : (_appsWebsiteUsageList2 = _appsWebsiteUsageList.appsWebsiteUsageList) === null || _appsWebsiteUsageList2 === void 0 ? void 0 : _appsWebsiteUsageList2.length
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$apps;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if (((_fetchMoreResult$apps = fetchMoreResult.appsWebsiteUsageListingUser) === null || _fetchMoreResult$apps === void 0 ? void 0 : _fetchMoreResult$apps.appsWebsiteUsageList.length) < LIMIT && !isUserAllLoaded) {
          setUserIsAllLoaded(true);
          setUserIsLoadingMore(false);
        }
        setUserIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          appsWebsiteUsageListingUser: _objectSpread(_objectSpread({}, prev.appsWebsiteUsageListingUser), {}, {
            appsWebsiteUsageList: [].concat(_toConsumableArray(prev.appsWebsiteUsageListingUser.appsWebsiteUsageList), _toConsumableArray(fetchMoreResult.appsWebsiteUsageListingUser.appsWebsiteUsageList))
          })
        });
      }
    });

    //setLimits(LIMIT + 20);
    // }
  }
  var totalTimeArray = React.useMemo(function () {
    var _appsWebsiteUsageList3;
    var usages = appsWebsiteUsageListingData === null || appsWebsiteUsageListingData === void 0 ? void 0 : (_appsWebsiteUsageList3 = appsWebsiteUsageListingData.appsWebsiteUsageListing) === null || _appsWebsiteUsageList3 === void 0 ? void 0 : _appsWebsiteUsageList3.appsWebsiteUsageList;
    if (!usages) return [];
    return usages.reduce(function (acc, curr) {
      if (acc.some(function (ac) {
        return ac.name === curr.name;
      })) {
        var isLargeNumber = function isLargeNumber(element) {
          return element.name === curr.name;
        };
        var index = acc.findIndex(isLargeNumber);
        var totalTime = Number(acc[index].totalSec) + Number(curr.totalSec);
        acc[index].totalSec = totalTime;
      } else {
        acc.push(_objectSpread({}, curr));
      }
      return acc;
    }, []);
  }, [appsWebsiteUsageListingData]);
  var totalTimeArrayTeam = React.useMemo(function () {
    var _appsWebsiteUsageList4;
    var usages = appsWebsiteUsageListingDataTeam === null || appsWebsiteUsageListingDataTeam === void 0 ? void 0 : (_appsWebsiteUsageList4 = appsWebsiteUsageListingDataTeam.appsWebsiteUsageListingTeam) === null || _appsWebsiteUsageList4 === void 0 ? void 0 : _appsWebsiteUsageList4.appsWebsiteUsageList;
    if (!usages) return [];
    return usages.reduce(function (acc, curr) {
      if (acc.some(function (ac) {
        return ac.name === curr.name;
      })) {
        var isLargeNumber = function isLargeNumber(element) {
          return element.name === curr.name;
        };
        var index = acc.findIndex(isLargeNumber);
        var totalTime = Number(acc[index].totalSec) + Number(curr.totalSec);
        acc[index].totalSec = totalTime;
      } else {
        acc.push(_objectSpread({}, curr));
      }
      return acc;
    }, []);
  }, [appsWebsiteUsageListingDataTeam]);
  React.useEffect(function () {
    if (!totalTimeArray || totalTimeArray.length === 0 || activeApps != null) return;
    var allAppsTitle = totalTimeArray.map(function (app) {
      return app.appId;
    });
    setActiveApps(allAppsTitle);
  }, [totalTimeArray, activeApps]);
  React.useEffect(function () {
    if (!totalTimeArrayTeam || totalTimeArrayTeam.length === 0 || activeApps != null) return;
    var allAppsTitle = totalTimeArrayTeam.map(function (app) {
      return app.appId;
    });
    setActiveApps(allAppsTitle);
  }, [totalTimeArrayTeam, activeApps]);
  React.useEffect(function () {
    if (tabData == "usage-per-employee") {
      getUser({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
          limit: LIMIT,
          offset: 0,
          activeApps: activeApps === null || activeApps.length === 0 ? [] : activeApps
        }
      });
    }
  }, [activeApps]);
  if (appsWebsiteUsageListingLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (appsWebsiteUsageListingError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!appsWebsiteUsageListingData) {
    return null;
  }
  var chartColor = [];
  for (var i = 0; i <= totalTimeArray.length; i++) {
    chartColor.push(colors[i]);
  }
  if ((appsWebsiteUsageListingDataUser === null || appsWebsiteUsageListingDataUser === void 0 ? void 0 : (_appsWebsiteUsageList5 = appsWebsiteUsageListingDataUser.appsWebsiteUsageListingUser) === null || _appsWebsiteUsageList5 === void 0 ? void 0 : (_appsWebsiteUsageList6 = _appsWebsiteUsageList5.appsWebsiteUsageList) === null || _appsWebsiteUsageList6 === void 0 ? void 0 : _appsWebsiteUsageList6.length) !== 0 && (appsWebsiteUsageListingDataUser === null || appsWebsiteUsageListingDataUser === void 0 ? void 0 : (_appsWebsiteUsageList7 = appsWebsiteUsageListingDataUser.appsWebsiteUsageListingUser) === null || _appsWebsiteUsageList7 === void 0 ? void 0 : (_appsWebsiteUsageList8 = _appsWebsiteUsageList7.appsWebsiteUsageList) === null || _appsWebsiteUsageList8 === void 0 ? void 0 : _appsWebsiteUsageList8.length) < LIMIT && !isUserAllLoaded) {
    setUserIsAllLoaded(true);
  }
  var UnreadAllOnchange = function UnreadAllOnchange() {
    if (!unselectAll) {
      setActiveApps([]);
    } else {
      if (totalTimeArray && totalTimeArray.length !== 0) {
        var allAppsTitle = totalTimeArray.map(function (app) {
          return app.appId;
        });
        setActiveApps(allAppsTitle);
      }
    }
  };
  var handleTabSelect = function handleTabSelect(key) {
    setTabData(key);
    if (key === "usage-per-employee") {
      getUser({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
          limit: LIMIT,
          offset: 0,
          activeApps: activeApps === null || activeApps.length === 0 ? [] : activeApps
        }
      });
    }
    // else {
    //   getTeam({
    //     variables: {
    //       organisationId,
    //       teamId,
    //       startDate: Number(moment(startDate).format("x")),
    //       endDate: Number(moment(endDate ?? startDate).format("x")),
    //     },
    //   });
    // }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-secondary mb-3"
  }, "Apps/Websites Usage"), /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-data-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-3 d-flex align-items-center border-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 text-secondary font-weight-bold"
  }, "All Apps and Websites")), /*#__PURE__*/React.createElement("div", {
    className: "p-3 review-usage-root-data-app-listing-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-app-listing-unselect-all-div"
  }, /*#__PURE__*/React.createElement(Form.Check, null, /*#__PURE__*/React.createElement(Form.Check.Input, {
    id: "archived",
    type: "checkbox",
    className: "review-usage-root-app-listing-unselect-all-checkbox",
    checked: unselectAll,
    onChange: function onChange() {
      UnreadAllOnchange();
      setUnselectAll(!unselectAll);
    }
  }), /*#__PURE__*/React.createElement(Form.Check.Label, {
    "for": "archived",
    className: "review-usage-root-app-listing-unselect-all-checkbox-label"
  }, "Unselect All Apps/Sites"))), totalTimeArray.length ? totalTimeArray.map(function (appsData) {
    var activeAppsData = activeApps === null || activeApps === void 0 ? void 0 : activeApps.includes(appsData.appId);
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("review-usage-root-data-app-listing-content-data-card", {
        "review-usage-root-data-app-listing-content-data-card-selected": activeAppsData
      }),
      onClick: function onClick() {
        setActiveApps(function (prev) {
          if (prev.length === 0 && activeAppsData) return prev;
          return prev.includes(appsData.appId) ? prev.filter(function (a) {
            return a !== appsData.appId;
          }) : [].concat(_toConsumableArray(prev), [appsData.appId]);
        });
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: "review-usage-root-data-app-listing-content-data-card-icon",
      src: appsData.icon
    }), /*#__PURE__*/React.createElement("div", {
      className: "app-summary-listing-whole-div"
    }, /*#__PURE__*/React.createElement("p", {
      className: "review-usage-root-data-app-listing-content-data-card-name ".concat(activeAppsData ? "review-usage-root-data-app-listing-content-data-selected" : null)
    }, appsData.name), /*#__PURE__*/React.createElement("p", {
      className: "review-usage-root-data-app-listing-content-data-card-time ".concat(activeAppsData ? "review-usage-root-data-app-listing-content-data-selected" : null)
    }, appsData.totalTime)));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-list-no-text"
  }, "No data found!!!"))), /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-data-item"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "total-usage",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "total-usage",
    title: "Total Usage"
  }, /*#__PURE__*/React.createElement("div", {
    className: "review-usage-website-chart"
  }, /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "460px",
    chartType: "PieChart",
    loader: /*#__PURE__*/React.createElement("div", null, "Loading Chart"),
    data: [["Website", "Hours per Day", {
      role: "tooltip",
      type: "string",
      p: {
        html: true
      }
    }]].concat(_toConsumableArray(totalTimeArray.filter(function (app) {
      return activeApps === null || activeApps === void 0 ? void 0 : activeApps.includes(app.appId);
    }).map(function (app) {
      var timeInHrs = convertSecToHoursAndMinutesWithTextShortForm(Number(app.totalSec));
      return [app.name, app.totalSec, "<div class=\"apps-tootlip\">\n                            <span class=\"apps-tootlip-title\">".concat(app.name, "</span>\n                            <br>\n                            <span class=\"apps-tootlip apps-tootlip-time\">Time: ").concat(timeInHrs, "</span>\n                          </div>")];
    }))),
    options: {
      legend: {
        position: "bottom",
        textStyle: {
          fontSize: "100px"
        }
      },
      pieSliceText: "none",
      chartArea: {
        width: "90%",
        height: "80%"
      },
      // colors: ["#4F26FF", "#691AFF", "#2DA5E0", "#23F3FF", "#8BC8E6", "#8747FF", "#5383DB"],
      colors: chartColor,
      pieHole: 0.5,
      tooltip: {
        isHtml: true,
        trigger: "visible"
      }
    }
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "usage-per-employee",
    title: "Usage Per Employee"
  }, /*#__PURE__*/React.createElement("div", {
    className: "review-usage-website-usage-per-employee"
  }, /*#__PURE__*/React.createElement(Table, {
    borderless: true
  }, /*#__PURE__*/React.createElement("thead", {
    className: "review-usage-website-usage-per-employee-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Team"), /*#__PURE__*/React.createElement("th", null, "App/Website"), /*#__PURE__*/React.createElement("th", null, "Total Time"))), appsWebsiteUsageListingDataUser !== undefined ? (appsWebsiteUsageListingDataUser === null || appsWebsiteUsageListingDataUser === void 0 ? void 0 : (_appsWebsiteUsageList9 = appsWebsiteUsageListingDataUser.appsWebsiteUsageListingUser) === null || _appsWebsiteUsageList9 === void 0 ? void 0 : _appsWebsiteUsageList9.appsWebsiteUsageList.length) == 0 ? /*#__PURE__*/React.createElement("td", {
    colSpan: 8,
    className: "app-summary-user-no-data"
  }, "No data found !!!") : /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(React.Fragment, null, appsWebsiteUsageListingDataUser.appsWebsiteUsageListingUser.appsWebsiteUsageList
  // .filter((app) => {
  //   return activeApps?.includes(app.appId);
  // })
  .map(function (app) {
    var _app$user, _app$user2, _app$user3, _app$user4, _app$user5;
    return /*#__PURE__*/React.createElement("tr", {
      className: "review-usage-website-usage-per-employee-table-content"
    }, /*#__PURE__*/React.createElement("td", {
      className: "review-usage-website-usage-per-employee-table-profile-content"
    }, app !== null && app !== void 0 && (_app$user = app.user) !== null && _app$user !== void 0 && _app$user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "review-usage-user-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: app === null || app === void 0 ? void 0 : (_app$user2 = app.user) === null || _app$user2 === void 0 ? void 0 : _app$user2.profileUrl,
      className: "review-usage-user-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "review-usage-website-usage-per-employee-table-content-avatar"
    }, app === null || app === void 0 ? void 0 : (_app$user3 = app.user) === null || _app$user3 === void 0 ? void 0 : _app$user3.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "user-name",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-team-name"
      }, app.user.displayName)
    }, /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat((_app$user4 = app.user) === null || _app$user4 === void 0 ? void 0 : _app$user4.uniqueUrl)), {
      key: "risk-".concat((_app$user5 = app.user) === null || _app$user5 === void 0 ? void 0 : _app$user5.userId)
    }), /*#__PURE__*/React.createElement("p", {
      className: "review-app-use-per-employee-name"
    }, app.user.displayName)))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "team-name",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-team-name"
      }, app.team.teamName)
    }, /*#__PURE__*/React.createElement("p", {
      className: "review-app-use-per-team-name"
    }, app.team.teamName))), /*#__PURE__*/React.createElement("td", null, app.name), /*#__PURE__*/React.createElement("td", null, app.totalTime));
  }), !appsWebsiteUsageListingLoadingUser && appsWebsiteUsageListingDataUser && appsWebsiteUsageListingDataUser.appsWebsiteUsageListingUser.appsWebsiteUsageList.length != 0 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, !isUserAllLoaded ? isUserLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "app-summary-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleScroll();
    },
    className: "app-summary-usage-load-more-button"
  }, "Load More") : !appsWebsiteUsageListingLoadingUser && appsWebsiteUsageListingDataUser && appsWebsiteUsageListingDataUser.appsWebsiteUsageListingUser.appsWebsiteUsageList.length ? /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button review-usage-light-color"
  }, "You have seen all the data") : null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)) : null)) : /*#__PURE__*/React.createElement("td", {
    colSpan: 8
  }, /*#__PURE__*/React.createElement(Loader, null)))))))));
};
export default AppsSummary;